import global from './global.js';
import multiselect from './multiselect';

export default {
    global,
    multiselect
}
